//
import axios from "axios"
import AccountingBankCardModel from "@/models/General/AccountingBankCard"
import { getFetchDataFunction } from '@/services/api/DataTableService'

/**
 * 
 */
const appends = [

]

/**
 * 
 */
const includes = [
    "accounting_bank_card_movement_detail",
    "accounting_bank_card_branch_office",
    "g_user.hr_employee",
]

/**
 * 
 */
const fetchAll = async () => {

    //
    try {

        //
        const response = await AccountingBankCardModel.params({ get_all_results: true }).include( includes ).get()

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

/**
 * 
 */
const fetchById = async id => {

    //
    try {

        //
        const response = await AccountingBankCardModel.include( includes ).find( id )

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

/**
 * 
 */
const dtFetchData = getFetchDataFunction( process.env.VUE_APP_API_ROUTE + '/accounting_bank_card_chile', includes, appends )


/**
 * 
 */
const generatePayment = async data => {

    //
    try {

        //
        const response = await axios.post( process.env.VUE_APP_API_ROUTE + '/accounting_bank_card_chile/generatePayment', data )

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

//
export default { 
    dtFetchData, 
    fetchAll, 
    fetchById, 
    generatePayment,
}
